import {
    FILTER_MAP_VENDEDOR,
    HIDE_POPUP_CLIENT,
    RECEIVE_DATA,
    RECEIVE_V_LIST,
    RECEIVE_OLAS_LIST,
    SET_MASK,
    SET_ORDER,
    SET_SELECTED_ROW,
    SHOW_POPUP_CLIENT,
    UPDATE_FIELD_FILTER,
    UPDATE_TABLE_COLUMN
} from './types';

const initialState = {
    loading: false,
    data: [],
    dVendedor: '',
    openPopup: false,
    filters: {
        distribuidorId: 0,
        supervisorId: '',
        ubigeoId: 0,
        marcaidentificacionId: 0,
        identificacionId: 0,
        tipoId:0,
        nombre: '',
        departamentoId:'00',
        provinciaId:'00',
        distritoId:'00',
        dProvincia:'',
        dDistrito:'',
        dIdentificacion:'',
        dMarcaIdentificacion:'',
        clienteId:0,
        dCliente:'',
        dDepartamento: '',
        vendedorId: '',
        dTipo:'',
        desde: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        hasta: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        dDistribuidor: '',
        dSupervisor: '',
        dVendedor: '',
        dUbigeo: '',
    },
    store: {
        loading: false,
        data: [],
        selected: [],
    },
    storePed: {
        data: [],
        selected: [],
    },
    storeClient: {
        data: [],
        selected: []
    },
    table: {
        order: 'asc',
        orderBy: '',
        columns: [
            { dataKey: 'Fecha', label: 'Fecha', width: 150, textAlign: 'right' },
            { dataKey: 'Nit', label: 'RUC', width: 100 },
            { dataKey: 'NombreComercial', label: 'Cliente', width: 250 , textAlign: 'right'},
            { dataKey: 'Tipo', label: 'Tipo de Afiche', width: 150, textAlign: 'right' },
            { dataKey: 'Nombre', label: 'Marca', width: 150 },
            { dataKey: 'Observacion', label: 'Observación', width: 250 },
            { dataKey: 'Departamento', label: 'Departamento', width: 150 },
            { dataKey: 'Provincia', label: 'Provincia', width: 150 },
            { dataKey: 'Distrito', label: 'Distrito', width: 150 }
        ]
    },
    tableClient: {
        order: 'asc',
        orderBy: '',
        columns: [
            { dataKey: 'dClienteSucursal', label: 'Punto de Venta', width: 350 },
            { dataKey: 'montoPedido', label: 'Monto Pedido', type: 'number', width: 100 },
            { dataKey: 'Ejecutado', label: 'Visita', type: 'boolean', width: 75 },
            { dataKey: 'conPedido', label: 'Fuera de Ruta', type: 'boolean', width: 175, backcolor: 'black' },
            { dataKey: 'motivoVisita', label: 'Motivo', width: 235 },
            { dataKey: 'motivoNoCompra', label: 'M. No Compra', width: 235 },
            { dataKey: 'EsProspecto', label: 'Prospecto', type: 'boolean', width: 75 },
            { dataKey: 'channelMap', label: 'Channel', type: 'boolean', width: 75 },
            { dataKey: 'fechaVisita', label: 'Fecha', width: 90 },
            { dataKey: 'horaVisita', label: 'Hora', width: 90 },  
        ]
    },
};

export const reportepromocionesReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case FILTER_MAP_VENDEDOR:
            return {
                ...state,
                dVendedor: action.dVendedor || ''
            };
        case HIDE_POPUP_CLIENT:
            return {
                ...state,
                openPopup: false
            };
        case RECEIVE_DATA:
            return {
                ...state,
                data: action.payload,
                store: {
                    ...state.store,
                    data: action.storeData
                }
            };
        case RECEIVE_V_LIST:
                return {
                    ...state,
                    store: {
                        ...state.store,
                        loading: false,
                        total: action.total,
                        data: action.payload,
                        source: null
                    }
            };
        case RECEIVE_OLAS_LIST:

            return {
                ...state,
                data: action.pay,
                storePed: {
                    ...state.store,
                    data: action.storePed
                }
            };

        case SET_MASK:
            return {
                ...state,
                loading: action.loading
            };
        case SET_ORDER:
            return {
                ...state,
                table: {
                    ...state.table,
                    order: action.order,
                    orderBy: action.orderBy
                }
            };
        case SET_SELECTED_ROW:
            return {
                ...state,
                store: {
                    ...state.store,
                    selected: action.selected
                }
            };
        case UPDATE_FIELD_FILTER:
            return { 
                ...state,
                filters: {
                    ...state.filters,
                    [action.key]: action.value
                }
            };
        case SHOW_POPUP_CLIENT:
            return {
                ...state,
                openPopup: true,
                storeClient: {
                    ...state.store,
                    data: action.storeData
                }
            };
        case UPDATE_TABLE_COLUMN:
            return {
                ...state,
                table: {
                    ...state.table,
                    columns: action.columns
                }
            };
        default:
            return state;
    }
}